import Tabs from './tabs';
export * from './tabs';
export default Tabs;
